import React from 'react';

const QuantityBonuses: React.FC = () => {
  return (
    <div className="quantity-bonuses">
      <h1>Mengen-Boni</h1>
      <p>Konfiguration von Bonusstaffeln und Rabatten.</p>
    </div>
  );
};

export default QuantityBonuses;
